import React, { useState, useEffect } from 'react';
import './HintButtons.css';

const HintButtons = ({ bookName, level, chunk, hints: providedHints = [], onHintClick, onReferenceContent }) => {
  const [hints, setHints] = useState(providedHints);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openHints, setOpenHints] = useState(new Set());

  // Map URL book names to folder names
  const bookFolderMap = {
    'Roland': 'SongOfRoland',
    'DivineComedy': 'DivineComedy',
    'Odyssey': 'Odyssey',
    'Iliad': 'Iliad',
    'Antigone': 'Antigone',
    'Oedipus': 'Oedipus',
    'HuckFinn': 'HuckFinn'
  };

  const bookFolder = bookFolderMap[bookName] || bookName;

  useEffect(() => {
    const loadHints = async () => {
      try {
        if (providedHints.length > 0) {
          setHints(providedHints);
          setLoading(false);
          return;
        }

        setLoading(true);
        
        // Load hints from the book's hint folder
        const hintsPath = `/content/books/${bookFolder}/hints/${level}/${chunk}.json`;
        
        const hintsResponse = await fetch(hintsPath);
        
        if (hintsResponse.ok) {
          const hintsData = await hintsResponse.json();
          setHints(hintsData.hints || []);
        } else {
          // Set default hints if file doesn't exist
          setHints([]);
        }
      } catch (error) {
        setError('Failed to load hints');
        setHints([]);
      } finally {
        setLoading(false);
      }
    };

    loadHints();
  }, [bookName, level, chunk, bookFolder, providedHints]);

  const handleHintClick = (hintNumber) => {
    if (onHintClick) {
      onHintClick(hintNumber);
    }
    
    // Toggle hint display - add or remove from open hints set
    setOpenHints(prevHints => {
      const newHints = new Set(prevHints);
      if (newHints.has(hintNumber)) {
        newHints.delete(hintNumber);
      } else {
        newHints.add(hintNumber);
      }
      return newHints;
    });
  };

  if (loading) {
    return (
      <div className="hint-buttons-container">
        <div className="hint-loading">Loading hints...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="hint-buttons-container">
        <div className="hint-error">Error loading hints: {error}</div>
      </div>
    );
  }

  return (
    <div className="hint-buttons-container">
      <div className="hint-instructions">
        Need help on the multiple choice questions? Click on the buttons below for hints (Note: button number corresponds to the Google Form question number):
      </div>
      
      <div className="hint-buttons">
        {hints.length > 0 ? (
          hints.map((hint) => (
            openHints.has(hint.number) ? (
              <div key={hint.number} className="hint-content">
                <div className="hint-content-text">
                  {hint.content}
                </div>
              </div>
            ) : (
              <button
                key={hint.number}
                className="hint-button"
                onClick={() => handleHintClick(hint.number)}
              >
                Hint {hint.number}
              </button>
            )
          ))
        ) : (
          // Show default hint buttons if no hints file exists
          Array.from({ length: 6 }, (_, i) => (
            openHints.has(i + 1) ? (
              <div key={i + 1} className="hint-content">
                <div className="hint-content-text">
                  Default hint content for question {i + 1}
                </div>
              </div>
            ) : (
              <button
                key={i + 1}
                className="hint-button"
                onClick={() => handleHintClick(i + 1)}
              >
                Hint {i + 1}
              </button>
            )
          ))
        )}
      </div>
      
    </div>
  );
};

export default HintButtons;
